import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: BrowsingHistoryState = {
  history: [],
};

const addHistory: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistoryItem>> = (state, action) => {
  if (state.history.find((his) => his.link === action.payload.link)) {
    return;
  }
  state.history = [...state.history, action.payload];
};

const deleteHistory: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistoryItem>> = (state, action) => {
  state.history = state.history.filter((his) => his.link !== action.payload.link);
};

const addHistorySearchParams: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistorySearchParams>> = (
  state,
  action
) => {
  if (!state.history.some((his) => his.link === action.payload.link)) {
    return;
  }
  state.history = state.history.map((item) => {
    return item.link === action.payload.link ? { ...item, searchParams: action.payload.searchParams } : item;
  });
};

const addSearchHistory: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistoryItem>> = (state, action) => {
  state.history = state.history.some((his) => his.link === action.payload.link && his.type === action.payload.type)
    ? state.history.map((item) => {
        return action.payload.link === item.link && action.payload.type === item.type
          ? {
              link: action.payload.link,
              label: action.payload.label,
              searchParams: action.payload.searchParams,
              type: action.payload.type,
            }
          : item;
      })
    : [...state.history, action.payload];
};

const addPageSize: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistoryPageSize>> = (state, action) => {
  if (!state.history.some((his) => his.link === action.payload.link)) {
    return;
  }
  state.history = state.history.map((item) => {
    return item.link === action.payload.link ? { ...item, pageSize: action.payload.pageSize } : item;
  });
};

const clearHistory: CaseReducer<BrowsingHistoryState> = (state) => {
  state.history = [];
};

const updateHistory: CaseReducer<BrowsingHistoryState, PayloadAction<BrowsingHistoryItem[]>> = (state, action) => {
  state.history = [...action.payload];
};

const historySlice = createSlice({
  name: 'historySlice',
  initialState,
  reducers: {
    addHistory,
    deleteHistory,
    addHistorySearchParams,
    addSearchHistory,
    addPageSize,
    clearHistory,
    updateHistory,
  },
});

export const historyActions = historySlice.actions;

export default historySlice.reducer;
